var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReferralsNavIcon from './icons/nav-icon-referrals.svg';
import { useFeatureFlags } from '../../infra/feature-flags';
export var withClientReferralsNavButton = function (WrappedComponent) {
    var WithClientReferralsNavButton = function (props) {
        var clientReferrals = useFeatureFlags().clientReferrals;
        var clientReferralsButton = {
            id: 'client-referrals',
            text: 'Referrals',
            iconName: ReferralsNavIcon,
            url: '/client-referrals',
            show: clientReferrals,
            label: {
                text: 'Beta',
                when: true,
            },
        };
        return _jsx(WrappedComponent, __assign({}, props, { clientReferralsButton: clientReferralsButton }));
    };
    WithClientReferralsNavButton.displayName = "withClientReferralsNavButton(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");
    return WithClientReferralsNavButton;
};
